// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"bdad6c60","322":"0cd9f2c0","453":"0d1b6e5a","615":"d38788ff"}[chunkId] + ".chunk.js";
};